import { Injectable } from "@angular/core";
import {
  HttpClient,
  HttpHeaders,
} from "@angular/common/http";
import { environment } from "../../../environments/environment";
import "rxjs/add/operator/map";
import { Observable } from "rxjs";
import { ICustomerPoints, SpendCustomerPoints } from "../../master-models/customer-points.model";

@Injectable()
export class CustomerPointsService {
  url = `${environment.apiBaseUrl}api/customer_points`;

  constructor(private http: HttpClient) {}

  getCustomerPoints(
    customerId: number, 
    status: string = '',
    fromDate: string = '',
    untilDate: string = '',
  ): Observable<{success: boolean, data: ICustomerPoints[]}> {
    const params: any = {};
    if (status) {
      params.status = status;
    }
    
    if (fromDate && untilDate) {
      params.start_date = fromDate;
      params.end_date = untilDate;
    }

    return this.http.get<{success: boolean, data: ICustomerPoints[]}>(`${this.url}/${customerId}`, {
      headers: this.getHeaders(),
      params
    });
  }

  spendPoints(spendPoints: SpendCustomerPoints): Observable<{success: boolean, message: string}> {
    return this.http.post<{success: boolean, message: string}>(this.url, spendPoints, {
      headers: this.getHeaders()
    });
  }

  cancelPoints(id: number): Observable<{success: boolean, data: ICustomerPoints}> {
    return this.http.patch<{success: boolean, data: ICustomerPoints}>(`${this.url}/${id}`, {}, {
      headers: this.getHeaders()
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");
    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/master-services/customer-points/customer-points.service.ts